import { Alert } from 'antd'
import classNames from 'classnames'
import { useIntl } from 'react-intl'
import { useIntercom } from 'react-use-intercom'

import { useThemeContext } from '@/context/ThemeContext'
import { buildI18nFunction } from '@/utils/messages'
import { WorkspaceAlerts } from '@/utils/workspaces'

import { WorkspaceBroadcastStatus } from '@/types/index.d'

import styles from './UsageAlert.module.css'

const COMPONENT_ID = 'WorkspaceCustomerSuccessAlert'

export type StatusAlert = Exclude<WorkspaceBroadcastStatus, 'NO_ALERT'>

type WorkspaceCustomerSuccessAlertProps = {
  status: StatusAlert
}

export function WorkspaceCustomerSuccessAlert({
  status,
}: WorkspaceCustomerSuccessAlertProps) {
  const t = buildI18nFunction(useIntl().formatMessage)
  const { showNewMessage: showIntercom } = useIntercom()
  const { isDarkMode } = useThemeContext()

  const alertType = getAlertBannerClassname(status)

  const className = classNames(styles['alert'], {
    [styles[alertType]]: true,
    [styles['alertDarkMode']]: isDarkMode,
  })

  return (
    <>
      <Alert
        banner
        showIcon={false}
        data-cy={COMPONENT_ID}
        className={className}
        style={{
          textAlign: 'center',
          height: 'auto',
        }}
        message={t(`${COMPONENT_ID}.alert.${status}.message`)}
        description={t(`${COMPONENT_ID}.alert.${status}.description`, {
          link: (
            <span
              className={styles['customerAlert']}
              onClick={() => showIntercom()}
            >
              {t(`${COMPONENT_ID}.alert.contactSupport`)}
            </span>
          ),
        })}
      />
    </>
  )
}

function getAlertBannerClassname(status) {
  switch (status) {
    case WorkspaceAlerts.TRUE_UP:
    case WorkspaceAlerts.UPCOMING_RENEWAL:
    case WorkspaceAlerts.OVERDUE_INVOICE_1:
      return 'ambercode'
    case WorkspaceAlerts.GRACE_PERIOD:
    case WorkspaceAlerts.OVERDUE_INVOICE_2:
      return 'redcode'
  }
}
